import type { CSSProperties } from 'react';

type SkeletonProps = {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
};

export const Skeleton = ({ width, height }: SkeletonProps) => {
  return (
    <div
      className="relative overflow-hidden rounded-dpDefault bg-dp-dark-200 opacity-30 before:absolute before:inset-0 before:-translate-x-full before:animate-dp-shimmer before:bg-gradient-to-r before:from-dp-dark-200 before:via-dp-dark-50 before:to-dp-dark-200 motion-reduce:before:hidden"
      style={{ width, height }}
    />
  );
};
